import PropTypes from 'prop-types'
import React, { Component } from 'react'
import i18n from 'simple-react-i18n'
import ProgressCard from '../../../../components/card/ProgressCard'
import Input from '../../../../components/forms/Input'
import Checkbox from '../../../../components/forms/Checkbox'
import SimpleTextArea from '../../../../components/forms/SimpleTextArea'
import PresentationCard from '../../../../components/card/PresentationCard'
import CenterIcon from '../../../../components/icon/CenterIcon'
import Job from '../../../dto/DtoJob'
import { Grid } from '@mui/material'

const MODE_DOWNLOAD = 'download'
const MODE_SEND = 'send'
const DEFAULT_SENDER = 'noreply@aquasys.fr'

class MailImportPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataLoaded: true,
            progress: 0,
        }
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    getFilters = () => this.props.job.parameters.filters.length ? JSON.parse(this.props.job.parameters.filters[0]) : {}

    render() {
        if (this.state.dataLoaded) {
            const disabled = !this.props.isEditMode
            const filters = this.getFilters()
            const isSendMode = filters.mode === MODE_SEND
            const centerStyle = {
                'align-items': 'center',
                display: 'flex',
                justifyContent: 'center',
            }
            return (
                <div>
                    <fieldset className='width-100'>
                        <legend>&nbsp;{ i18n.mailJobMode }&nbsp;</legend>
                        <Grid container justifyContent='center' alignItems='center' spacing={3}>
                            <Grid size={4}>
                                <PresentationCard
                                    iconComponent={<CenterIcon
                                        icon='file_download'
                                        color='#4f88b5'
                                        additionalStyle={{ paddingRight: 5 }}
                                    />}
                                    iconContainerStyle={centerStyle}
                                    title={ i18n.mailDownloadMode }
                                    onClick={() => this.onChangeFilters({ mode: MODE_DOWNLOAD })}
                                    isFocused={!isSendMode}
                                    description={ i18n.mailDownloadModeDescription }
                                    dashedBorder
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={4}>
                                <PresentationCard
                                    iconComponent={<CenterIcon
                                        icon='send'
                                        color='#4f88b5'
                                        additionalStyle={{ paddingRight: 5 }}
                                    />}
                                    iconContainerStyle={centerStyle}
                                    title={ i18n.mailSendMode }
                                    onClick={() => this.onChangeFilters({ mode: MODE_SEND })}
                                    isFocused={isSendMode}
                                    description={ i18n.mailSendModeDescription }
                                    dashedBorder
                                    disabled={ disabled }
                                />
                            </Grid>
                        </Grid>
                    </fieldset>
                    <div className='row no-margin valign-wrapper'>
                        <fieldset className='width-100'>
                            <legend>&nbsp;{ 'Paramétrages mail' }&nbsp;</legend>
                            {!isSendMode && <Input col={ 4 } title={ 'serveur mail' } onChange={ v => this.onChangeFilters({ mailHost: v }) } disabled={ disabled } value={ filters.mailHost } />}
                            {isSendMode && <Input col={ 4 } title={ i18n.mailSender } onChange={ v => this.onChangeFilters({ mailSender: v }) } disabled={ disabled } value={ filters.mailSender } placeholder={ DEFAULT_SENDER } />}
                            <Input col={ 4 } title={ isSendMode ? i18n.receiver : i18n.email } onChange={ v => this.onChangeFilters({ mailUser: v }) } disabled={ disabled } value={ filters.mailUser } />
                            {!isSendMode && <Input col={ 4 } title={ i18n.password } onChange={ v => this.onChangeFilters({ mailPassword: v }) } disabled={ disabled } value={ filters.mailPassword } passwordType/>}
                            {isSendMode && (
                                <Grid container spacing={2}>
                                    <Grid size={12}>
                                        <Input title={ i18n.mailSubject } onChange={ v => this.onChangeFilters({ mailSubject: v }) } disabled={ disabled } value={ filters.mailSubject } />
                                    </Grid>
                                    <Grid size={12}>
                                        <SimpleTextArea title={ i18n.mailBody } onChange={ v => this.onChangeFilters({ mailBody: v }) } disabled={ disabled } value={ filters.mailBody } rows={ 5 } />
                                    </Grid>
                                </Grid>
                            )}
                        </fieldset>
                    </div>
                    <div className='row no-margin padding-top-1'>
                        <Input col={ 5 } title={ 'Répertoire FTP' } onChange={ v => this.onChangeFilters({ ftpPath: v }) } disabled={ disabled } value={ filters.ftpPath } />
                        <Input col={ 5 } title={ 'Filtre du nom de fichier' } onChange={ v => this.onChangeFilters({ fileNameFilter: v }) } disabled={ disabled } value={ filters.fileNameFilter } />
                    </div>
                    {isSendMode && (
                        <Grid container spacing={2}>
                            <Grid size={4}><Checkbox label={i18n.renameDoneErrorFic} onChange={v => this.onChangeFilters(v ? { renameProcessedFiles: true, dontProcessFilesInLogs: false } : { renameProcessedFiles: false })} disabled={disabled} checked={filters.renameProcessedFiles} /></Grid>
                            <Grid size={4}><Checkbox label={i18n.dontProcessFilesInLogs} onChange={v => this.onChangeFilters(v ? { dontProcessFilesInLogs: true, renameProcessedFiles: false } : { dontProcessFilesInLogs: false })} disabled={disabled} checked={filters.dontProcessFilesInLogs} /></Grid>
                            <Grid size={4}><Checkbox label={i18n.replayErrorFiles} onChange={v => this.onChangeFilters({ replayErrorFiles: v })} disabled={disabled} checked={filters.replayErrorFiles} /></Grid>
                        </Grid>
                    )}
                </div>
            )
        }
        return <ProgressCard progress={ this.state.progress }/>
    }
}

MailImportPanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    onChangeJob: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
}

export default MailImportPanel